// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"22":"chunk-[request][index]","245":"notfound"}[chunkId] + "." + {"22":"1c659832","245":"bde9a437"}[chunkId] + ".css";
};